// extracted by mini-css-extract-plugin
export var core = "testimonials-module--core--ldL9Z";
export var arrow = "testimonials-module--arrow--OEsXZ";
export var slide = "testimonials-module--slide--eiELK";
export var play = "testimonials-module--play--MtMQ0";